import styled from 'styled-components';

import { device, hexToRGB } from '@/styles/helpers';

export const ScNewWinnerWrapp = styled.div`
  user-select: none;
  display: grid;
  grid-template-columns: 1fr 82px;
  column-gap: 26px;
  padding: 8px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayDarkColor};

  @media (${device.tablet}) {
    column-gap: 16px;
  }
  @media (${device.mobile}) {
    grid-template-columns: 1fr 66px;
  }

  & > .content {
    display: flex;
    column-gap: 16px;
    align-items: center;
    width: 100%;
    min-width: 0;

    & > .img-block {
      border-radius: 12px;
      overflow: hidden;
      flex-shrink: 0;
    }

    & > .winner-info {
      display: flex;
      flex-direction: column;
      min-width: 0;

      .winner {
        max-width: 100%;
        font-size: 14px;
        line-height: 20px;
        color: ${({ theme }) => theme.blackLightColor};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0.01em;
      }
      .prize {
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.01em;
        flex-shrink: 0;
      }
    }
  }

  .win-btn {
    color: ${({ theme }) => theme.whiteColor};
    align-self: stretch;
    display: grid;
    place-items: center;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.01em;
    transition: color 0.2s ease-in-out;
    padding: 0 24px;
    border-left: 1px solid ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    margin: 2px 0;
    flex-shrink: 0;

    @media (${device.tablet}) {
      padding: 0 16px;
    }

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.mainColor};
      }
    }
  }
`;
